import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { CloseIcon } from '../customStyles/images';

import theme from '../../theme';

const ModalTitle = ({ editMode, isLoading, modalContent, handleClose }) => {

  return (
    <Stack
      variant="between-center"
      sx={{
        padding: '16px 16px 16px 24px',
        borderBottom: `1px solid ${theme.palette.grey.w300}`,
      }}
    >
      <Typography
        variant='h3'
        sx={{ fontWeight: 700 }}
      >
        {
          editMode &&
          modalContent.subTitle
        }
        {
          !editMode &&
          modalContent.title
        }
      </Typography>

      {/* <IconButton
        variant='title'
        onClick={handleClose}
        disabled={isLoading ? true : false}
      >
        <CloseIcon variant='md_24'/>
      </IconButton> */}

    </Stack>
  )
}

export default ModalTitle;